import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, useUserSettingsStore } from '@pascal/pascal-core';
import { soundService } from '../../module/services/SoundService';


const SoundWatcher = observer(() => {
  const state = useRef({ musicPlayed: false });

  const { isSoundOn, isMusicOn } = useUserSettingsStore();

  const muteMusicAndSounds = useCallback(() => {
    soundService.muteMusic(document.hidden ? true : !isMusicOn);
    soundService.muteSounds(document.hidden ? true : !isSoundOn);
  }, [isMusicOn, isSoundOn]);

  useEffect(() => {
    soundService.muteMusic(!isMusicOn);
    if (isMusicOn) {
      soundService.playMusic();
    } else {
      soundService.stopMusic();
    }
  }, [isMusicOn]);

  useEffect(() => {
    soundService.muteSounds(!isSoundOn);
  }, [isSoundOn]);

  const handleDocumentCLick = useCallback(() => {
    if (!state.current.musicPlayed && isMusicOn) {
      soundService.playMusic().then(() => {
        soundService.playMusic();
      })
      state.current.musicPlayed = true
    }
  }, [isMusicOn, state.current.musicPlayed]);

  useEffect(() => {
    if (isMobile()) {
      document.addEventListener('visibilitychange', muteMusicAndSounds);
    }

    return () => {
      if (isMobile()) {
        document.removeEventListener('visibilitychange', muteMusicAndSounds);
      }
    };
  }, [muteMusicAndSounds]);

  useEffect(() => {
    document.addEventListener('click', handleDocumentCLick);
    return () => {
      document.removeEventListener('click', handleDocumentCLick);
    };
  }, [state.current]);


  return null;
});

export default SoundWatcher;
